export const topSeries = [
  { title: 'Dafna', slug: 'dafna' },
  { title: 'Terra Lounge', slug: 'terra-lounge' },
  { title: 'Flexi Light', slug: 'flexi-light' },
  { title: 'Arcus', slug: 'arcus' },
  { title: 'Nido', slug: 'nido' },
  { title: 'Melody Design', slug: 'melody-design' },
  { title: 'Flexi Lounge', slug: 'flexi-lounge' },
  { title: 'Lotus', slug: 'lotus' },
]
